// Process polyfill for browser compatibility
// This is a backup polyfill - the main one is in index.html

const processPolyfill = {
  env: {
    NODE_ENV: 'development',
    PUBLIC_URL: '',
    REACT_APP_CSMS_API_ENDPOINT: 'http://localhost:8080',
    REACT_APP_SERVER_URL: 'http://localhost:8080',
    REACT_APP_PORTAL_API_LINK: 'http://localhost:8080'
  }
};

// Function to safely set process on any object
function setProcessSafely(obj, name) {
  try {
    if (obj && typeof obj === 'object') {
      Object.defineProperty(obj, 'process', {
        value: processPolyfill,
        writable: true,
        enumerable: true,
        configurable: true
      });
    }
  } catch (e) {
    // Ignore errors
  }
}

// Only set if process is not already defined
try {
  // Check if process exists - use try-catch to handle ReferenceError
  let processExists = false;
  try {
    // eslint-disable-next-line no-undef
    processExists = typeof process !== 'undefined';
  } catch (e) {
    // process is not defined, which is what we want
    processExists = false;
  }

  if (!processExists) {
    // Set on all possible global contexts using Object.defineProperty
    setProcessSafely(typeof window !== 'undefined' ? window : null, 'window');
    setProcessSafely(typeof global !== 'undefined' ? global : null, 'global');
    // eslint-disable-next-line no-undef
    if (typeof globalThis !== 'undefined') {
      // eslint-disable-next-line no-undef
      setProcessSafely(globalThis, 'globalThis');
    }
    // eslint-disable-next-line no-restricted-globals
    setProcessSafely(typeof self !== 'undefined' ? self : null, 'self');
    
    // Also try direct assignment as fallback using Function constructor
    try {
      // Use Function constructor to set process in global scope
      // eslint-disable-next-line no-new-func
      const setProcess = new Function('processPolyfill', 'process = processPolyfill');
      setProcess(processPolyfill);
    } catch (e) {
      // If Function constructor fails, try eval
      try {
        // eslint-disable-next-line no-eval
        eval('process = processPolyfill');
      } catch (e2) {
        // Last resort - try setting on window explicitly
        try {
          if (typeof window !== 'undefined') {
            window.process = processPolyfill;
          }
        } catch (e3) {
          console.warn('Could not set process polyfill in JavaScript');
        }
      }
    }
  }
} catch (error) {
  // Process is already defined or there was an error
  // This is expected in most cases since the HTML polyfill should have set it
}

export default processPolyfill;
